/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DataInnerValue } from './DataInnerValue';
import {
    DataInnerValueFromJSON,
    DataInnerValueFromJSONTyped,
    DataInnerValueToJSON,
} from './DataInnerValue';

/**
 * 
 * @export
 * @interface ControlEntityIssuesFoundResponse
 */
export interface ControlEntityIssuesFoundResponse {
    /**
     * 
     * @type {Array<{ [key: string]: DataInnerValue; }>}
     * @memberof ControlEntityIssuesFoundResponse
     */
    data?: Array<{ [key: string]: DataInnerValue; }>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlEntityIssuesFoundResponse
     */
    categories?: Array<string>;
}

/**
 * Check if a given object implements the ControlEntityIssuesFoundResponse interface.
 */
export function instanceOfControlEntityIssuesFoundResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlEntityIssuesFoundResponseFromJSON(json: any): ControlEntityIssuesFoundResponse {
    return ControlEntityIssuesFoundResponseFromJSONTyped(json, false);
}

export function ControlEntityIssuesFoundResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlEntityIssuesFoundResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : json['data'],
        'categories': !exists(json, 'categories') ? undefined : json['categories'],
    };
}

export function ControlEntityIssuesFoundResponseToJSON(value?: ControlEntityIssuesFoundResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data,
        'categories': value.categories,
    };
}

